import {decorate, injectable} from '@yosmanyga/di';
import {action, observable, runInAction, makeObservable} from 'mobx';

// import Purchases from "react-native-purchases";

class BuyController {
    restoring: boolean;

    constructor() {
        this.restoring = false;
        
        makeObservable(this, {
            restoring: observable,
            restore: action,
        });
    }

    restore = async () => {
        runInAction(() => {
            this.restoring = true;
        });

        // try {
        //     const offerings = await Purchases.getOfferings();
        // } catch (e) {
        // }

        // try {
        //     const restore = await Purchases.restorePurchases();
        // } catch (e) {
        //
        // }

        runInAction(() => {
            this.restoring = false;
        });
    };
}

decorate(injectable(), BuyController);

export {BuyController};
